import React, { PropTypes } from 'react';
import { AuthorizedComponent } from 'react-router-role-authorization';
import { connect } from 'react-redux';
import { browserHistory, withRouter } from 'react-router';
import Spinner from 'react-spinkit';

import AssignmentForm, { CREATE } from "../components/AssignmentForm";
import {
    ASSIGNMENTS__REQUESTED,
    DROPBOXES__REQUESTED,
    ROLES__SELF__REQUESTED
} from "../constants/actionTypes";
import _ from "lodash";
import { INSTRUCTOR } from "../constants/roles";

class AssignmentCreatePage extends AuthorizedComponent {
    constructor(props) {
        super(props);

        this.userRoles = props.auth.roles;
        this.notAuthorizedPath = '/not-found';
    }

    componentDidMount() {
        const { dispatch } = this.props;

        dispatch({
            type: ROLES__SELF__REQUESTED
        });
    }

    componentDidUpdate(prevProps) {
        const { assignments, dispatch, dropboxes, params, roles_self } = this.props,
            dropboxId = parseInt(params.dropboxId)
        ;

        if (prevProps.roles_self !== roles_self) {
            const hasInstructorRole = _.includes(
                _.flatMap(
                    roles_self,
                    dropbox_role => {
                        if (dropbox_role.dropbox.id === dropboxId) {
                            return dropbox_role.role;
                        }
                    }),
                INSTRUCTOR
            );

            if (hasInstructorRole) {
                if (_.size(dropboxes) < 1) {
                    dispatch({
                        type: DROPBOXES__REQUESTED
                    });
                }

                if (_.size(assignments) < 1) {
                    dispatch({
                        type: ASSIGNMENTS__REQUESTED,
                    });
                }
            } else {
                browserHistory.push('/not-found');
            }
        }
    }

    render() {
        const isLoading = this.props.request.sendingRequest;
        if (isLoading) {
            return (
                <Spinner
                    spinnerName="wandering-cubes"
                    className="spinner"
                    noFadeIn
                />
            );
        }

        let { params, dropboxes } = this.props;

        return (
            <div className="table-responsive">
                {
                   _.map(
                        _.filter(
                            dropboxes,
                            dropbox => {
                                return dropbox.id === parseInt(params.dropboxId);
                            }
                        ),
                        dropbox => {
                           return (
                               <AssignmentForm
                                   key={"assignment_form"}
                                   className="submission-form"
                                   type={CREATE}
                                   params={params}
                                   assignment={{}}
                                   dropbox={dropbox}
                               />
                           );
                        }
                    )
                }
            </div>
        );
    }
}

AssignmentCreatePage.propTypes = {
    dispatch: PropTypes.func.isRequired,
    assignments: PropTypes.object.isRequired,
    dropboxes: PropTypes.object.isRequired,
    params: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
    request: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
    const { assignments, auth, dropboxes, request, roles_self } = state;

    return { assignments, auth, dropboxes, request, roles_self };
}

export default connect(mapStateToProps)(withRouter(AssignmentCreatePage));



/** WEBPACK FOOTER **
 ** ./src/containers/AssignmentCreatePage.js
 **/